import { JSX } from "react";
import { useAppSelector } from "../../../app/hooks";
import { getUserFullName } from "../../../common/utils/getUserFullName";

export const RejectCertificateModalHeader = (): JSX.Element => {
    const { selectedCertificate } = useAppSelector(
        (state) => state.rejectCertificateModal,
    );

    return (
        <div className={"c-reject-certificate-modal__header"}>
            <h2>Certificaat afkeuren</h2>
            <p>
                Je staat op het punt om onderstaand certificaat van medewerker{" "}
                <b>{getUserFullName(selectedCertificate.employee.user)}</b> af
                te keuren:
            </p>
        </div>
    );
};
